import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import FileBase64 from "react-file-base64";

import Button from "./Button";
import TextInput from "./TextInput";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import zIndex from "@material-ui/core/styles/zIndex";

export default class SendMailToClassWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMailKey: Math.random(),
      editorState: EditorState.createEmpty(),
      subject: "",
      selectedEmails: [],
      contentState: null,
    };
  }

  reset() {
    this.setState({
      sendMailKey: Math.random(),
      editorState: EditorState.createEmpty(),
      subject: "",
      selectedEmails: [],
      contentState: null,
    });
  }

  onContentStateChange = (contentState) => {
    this.savedEnabled = true;
    console.log("as HTML:", draftToHtml(contentState));
    this.setState({ contentState });
  };

  toggleStudent = (email) => {
    // Aggiunge o rimuove la mail dello studente dallo stato
    let { selectedEmails } = this.state;
    if (selectedEmails.includes(email)) {
      selectedEmails = selectedEmails.filter((e) => e !== email);
    } else {
      selectedEmails = [...selectedEmails, email];
    }
    this.setState({ selectedEmails });
  };

  toggleSelectAll = () => {
    const { studentiAttivi } = this.props;
    if (this.state.selectedEmails.length === studentiAttivi.length) {
      this.setState({ selectedEmails: [] });
    } else {
      const emails = studentiAttivi
        .map((student) => student.mail)
        .filter((mail) => mail && mail.trim() !== "");
      this.setState({ selectedEmails: emails });
    }
  };

  render() {
    const { studentiAttivi } = this.props;

    return (
      <div style={{ display: this.props.show ? "block" : "none" }}>
        <div style={container}>
          <div style={mainClass}>
            <div style={closeBtn} onClick={() => this.props.onClose()}>
              X
            </div>
            <div style={title}>Invia Mail</div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Seleziona Studenti:
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>
                  <input
                    type="checkbox"
                    checked={
                      studentiAttivi &&
                      this.state.selectedEmails.length === studentiAttivi.length
                    }
                    onChange={this.toggleSelectAll}
                  />{" "}
                  Seleziona tutti
                </label>
              </div>
              <div
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                  paddingRight: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "10px",
                  backgroundColor: "#f9f9f9",
                  boxShadow: "inset 0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                {studentiAttivi &&
                  studentiAttivi.map((student, index) => (
                    <div
                      key={student.id}
                      style={{
                        borderBottom:
                          index < studentiAttivi.length - 1
                            ? "1px solid #e0e0e0"
                            : "none",
                        paddingBottom: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      <label style={{ cursor: "pointer", display: "block" }}>
                        <input
                          type="checkbox"
                          checked={this.state.selectedEmails.includes(
                            student.mail
                          )}
                          onChange={() => this.toggleStudent(student.mail)}
                        />{" "}
                        {student.nome} {student.cognome}
                      </label>
                    </div>
                  ))}
              </div>
              {studentiAttivi && studentiAttivi.length > 5 && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px",
                    fontStyle: "italic",
                    textAlign: "center",
                  }}
                >
                  ↕️ Scorri per vedere tutti i {studentiAttivi.length} studenti
                </div>
              )}
            </div>

            <div>Oggetto:</div>
            <TextInput
              name={""}
              value={this.state.subject}
              onChange={(text) => this.setState({ subject: text })}
            />
            <br />
            <br />
            <div>Testo:</div>
            <div style={bodyMsg}>
              <Editor
                editorState={this.state.editorState}
                onContentStateChange={this.onContentStateChange}
                onEditorStateChange={(editorState) =>
                  this.setState({ editorState })
                }
                toolbarClassName="demo-toolbar-custom"
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor-custom"
                toolbar={{
                  options: ["inline", "fontSize", "fontFamily", "colorPicker"],
                  inline: {
                    options: ["bold", "italic", "underline"],
                    bold: { className: "bordered-option-classname" },
                    italic: { className: "bordered-option-classname" },
                    underline: { className: "bordered-option-classname" },
                  },
                }}
              />
            </div>
            <br />
            <FileBase64
              key={this.state.sendMailKey}
              multiple={false}
              onDone={(files) => this.setState({ files })}
            />
            {this.state.files ? (
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  this.setState({
                    files: undefined,
                    sendMailKey: Math.random(),
                  })
                }
              >
                Elimina allegato
              </div>
            ) : null}
            <br />
            <br />
            <Button
              callback={() => {
                const subject = this.state.subject;
                const body = draftToHtml(this.state.contentState);
                if (!subject) {
                  alert("Check the subject");
                  return;
                }
                this.props.onSend(
                  subject,
                  body,
                  this.state.files,
                  this.state.selectedEmails
                );
              }}
              title="INVIA"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mainClass = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxHeight: "90vh",
  overflow: "auto",
  border: "1px solid black",
  background: "#ffffff",
  padding: "2%",
  borderRadius: "8px",
  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
};

const container = {
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "rgba(0, 0, 0, 0.5)",
  zIndex: 9999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const title = {
  position: "relative",
  textAlign: "center",
  width: "100%",
  fontWeight: "bold",
};

const bodyMsg = {
  border: "1px solid black",
  height: "200px",
};

const inputText = {
  width: "300px",
  padding: "10px",
};

const closeBtn = {
  position: "absolute",
  right: "1%",
  top: "1%",
  cursor: "pointer",
};
